import { render } from "./SubmitTicketForm.vue?vue&type=template&id=5bc0ad96"
import script from "./SubmitTicketForm.vue?vue&type=script&lang=js"
export * from "./SubmitTicketForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__